import React from "react";
import styles from "./setBundleProduct.scss";
import {
  getProductStatus,
  isAddToCartDisabled,
} from "../../../../common/utils/helper";
import EstimatedInstockTime from "../../../../common/components/estimatedInstockTime/estimatedInstockTime";
import NoTranslate from "../../../../common/components/notranslate/noTranslate";
import NewSpinner from "@tw/shared-ui-components/lib/components/newSpinner/newSpinner";

const SetBundleProduct = (props) => {
  const {
    isDefault,
    product,
    quantity,
    onItemQuantityChange,
    disableButtons,
    disableAddButtons,
    loadingProduct,
    promotionDetails,
  } = props;

  const intlNumberFormatter = new Intl.NumberFormat("en-US");

  const isProductDisabled = isAddToCartDisabled(product?.productStatus);

  const enableAddItem = isProductDisabled
    ? false
    : !disableButtons && !disableAddButtons && quantity < 99;

  const enableRemoveItem = isProductDisabled
    ? false
    : !disableButtons && quantity > 0;

  const addItemHandler = () => {
    onItemQuantityChange(product.itemCode, quantity + 1);
  };
  const removeItemHandler = () => {
    onItemQuantityChange(product.itemCode, quantity - 1);
  };

  const productStatus = getProductStatus(product);

  if (!product) return null;

  return (
    <div
      className={`${styles["product"]} ${
        isProductDisabled ? styles["disabled"] : ""
      }`}
    >
      {isDefault && (
        <div className={styles["tag"]} style={{
          backgroundColor: promotionDetails.defaultTagBackgroundColor,
          color: promotionDetails.defaultTagColor,
        }}>
          { promotionDetails.defaultTag || '精選商品'}
        </div>
      )}
      <div className={styles["title"]}>{product.skuName}</div>
      <div className={styles["price-and-quantity"]}>
        <div className={styles["price"]}>
          <NoTranslate>
            $ {intlNumberFormatter.format(product.price)}
          </NoTranslate>
          {productStatus && (
            <span
              className={styles["status"]}
              style={{ color: productStatus.colorCode }}
            >
              {productStatus.label}
            </span>
          )}
        </div>
        {!isDefault && (
          <div className={styles["quantity-selector"]}>
            <div
              className={styles["icon"]}
              onClick={enableRemoveItem ? removeItemHandler : undefined}
              disabled={!enableRemoveItem}
            >
              <svg
                width="10"
                height="2.15"
                viewBox="0 0 10 2.15"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9.28571 0H0.714286C0.319866 0 0 0.319866 0 0.714286V1.42857C0 1.82299 0.319866 2.14286 0.714286 2.14286H9.28571C9.68013 2.14286 10 1.82299 10 1.42857V0.714286C10 0.319866 9.68013 0 9.28571 0Z" />
              </svg>
            </div>
            <div className={styles["quantity"]}>
              {loadingProduct === product?.itemCode ? <NewSpinner /> : quantity}
            </div>
            <div
              className={styles["icon"]}
              onClick={enableAddItem ? addItemHandler : undefined}
              disabled={!enableAddItem}
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M9.28571 3.92857H6.07143V0.714286C6.07143 0.319866 5.75156 0 5.35714 0H4.64286C4.24844 0 3.92857 0.319866 3.92857 0.714286V3.92857H0.714286C0.319866 3.92857 0 4.24844 0 4.64286V5.35714C0 5.75156 0.319866 6.07143 0.714286 6.07143H3.92857V9.28571C3.92857 9.68013 4.24844 10 4.64286 10H5.35714C5.75156 10 6.07143 9.68013 6.07143 9.28571V6.07143H9.28571C9.68013 6.07143 10 5.75156 10 5.35714V4.64286C10 4.24844 9.68013 3.92857 9.28571 3.92857Z" />
              </svg>
            </div>
          </div>
        )}
      </div>
      <EstimatedInstockTime value={product?.estimatedInstockTime} />
    </div>
  );
};

export default SetBundleProduct;
